import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { MessageStatus, MessageType, SessionStatus, getNewSession } from "../../../../shared/api";
import { CAPTCHA_BEFORE_BLOCKING_HISTORY_KEY, LIMIT_LAST_SESSION_UPDATE } from "../../../../shared/config";
import { comparisonDateDay, comparisonDateTime, getLastSession, sortDate } from "../../../../shared/lib";
export var checkIfLastSessionFinished = function checkIfLastSessionFinished(session) {
  return !session || session.status === SessionStatus.Finished;
};
export var addMessagesToLastSession = function addMessagesToLastSession(state) {
  var lastSession = getLastSession(state.history);
  if (lastSession) {
    var _lastSession$messages;
    // Убираем дубликаты по ключам (например при спаме капчи может появится 2 сообщения о блокировке);
    var currentMessageIds = lastSession.messages.map(function (el) {
      return el.messageId;
    });
    for (var _len = arguments.length, messages = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      messages[_key - 1] = arguments[_key];
    }
    (_lastSession$messages = lastSession.messages).push.apply(_lastSession$messages, _toConsumableArray(messages.filter(function (el) {
      return !currentMessageIds.includes(el.messageId);
    })));
  }
};
var prepareHistoryWithStorage = function prepareHistoryWithStorage(history, savedData) {
  var copyHistory = _objectSpread({}, history);
  var position = LIMIT_LAST_SESSION_UPDATE + 1;
  var slicedIndex = copyHistory.list.length > position ? copyHistory.list.length - position : 0;
  var slicedHistory = copyHistory.list.splice(slicedIndex);
  slicedHistory.forEach(function (item, index) {
    savedData.forEach(function (saved) {
      var _slicedHistory;
      var nextSessionDate = (_slicedHistory = slicedHistory[index + 1]) === null || _slicedHistory === void 0 ? void 0 : _slicedHistory.createdAt;
      var isSessionLast = nextSessionDate ? comparisonDateTime(nextSessionDate, saved.date) : true;
      var isReplay = slicedHistory[index].messages.find(function (el) {
        return el.messageId === saved.messageId;
      });
      if (comparisonDateTime(saved.date, item.createdAt) && isSessionLast && !isReplay) {
        var prefix = comparisonDateDay(saved.date, item.createdAt, nextSessionDate);
        slicedHistory[index + prefix].messages.push(saved);
      }
    });
    slicedHistory[index].messages.sort(function (a, b) {
      return sortDate(a.date, b.date);
    });
    copyHistory.list.push(slicedHistory[index]);
  });
  return copyHistory;
};

// Мутируем историю последние 2 сессии
export var prepareHistory = function prepareHistory(history) {
  var list = history.list.slice(-2);
  for (var i = 0; i < list.length; i += 1) {
    var messages = list[i].messages;
    for (var j = 0; j < messages.length; j += 1) {
      var message = messages[j];
      if (message.message.type === MessageType.Img) {
        message.messageStatus = 5;
      }
    }
  }
  return history;
};
export var createLocalHistory = function createLocalHistory(history) {
  var _sessionStorage$getIt;
  var savedData = JSON.parse((_sessionStorage$getIt = sessionStorage.getItem(CAPTCHA_BEFORE_BLOCKING_HISTORY_KEY)) !== null && _sessionStorage$getIt !== void 0 ? _sessionStorage$getIt : '[]');

  // Мутируем историю для автозагрузки фото
  var preparedHistory = prepareHistory(history);
  if (!savedData || (savedData === null || savedData === void 0 ? void 0 : savedData.length) === 0) {
    return preparedHistory;
  }
  return prepareHistoryWithStorage(preparedHistory, savedData);
};
export var sortSessionMessages = function sortSessionMessages(state) {
  var lastSession = getLastSession(state.history);
  lastSession === null || lastSession === void 0 || lastSession.messages.sort(function (a, b) {
    return sortDate(a.date, b.date);
  });
};
export var checkLastSession = function checkLastSession(state) {
  var lastSession = getLastSession(state.history);
  var isLastSessionFinished = checkIfLastSessionFinished(lastSession);
  if (isLastSessionFinished) {
    var newSession = getNewSession();
    state.history.list.push(newSession);
  }
};

/**
 * Алгоритм быстрого поиска актуальной сессии по времени
 * @param time - время отправки текущего сообщения
 * @param list - Список всех сессий
 * @returns [Session, index] - Сессия которая содержит сообщение с {time} и индекс этой сессии
 */
export var quickSearchSession = function quickSearchSession(time) {
  var _list$slice;
  var list = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var left = -1;
  var right = list.length;
  while (right - left > 1 && time) {
    var _list;
    /**
     * Находим сессию по шаблону:
     * время создания текущей сесии(list[middle]) < time(время отправленного сообщения) < время создания следующей сессии (list[middle+1])
     */
    var middle = Math.floor((left + right) / 2);
    var currentSession = list[middle];
    var nextSessionDate = (_list = list[middle + 1]) === null || _list === void 0 ? void 0 : _list.createdAt;
    var isLastSession = time >= currentSession.createdAt && !nextSessionDate;
    var isCorrectSession = time >= currentSession.createdAt && nextSessionDate && time < nextSessionDate;
    if (isCorrectSession || isLastSession) {
      return [currentSession, middle];
    }
    if (time < (currentSession === null || currentSession === void 0 ? void 0 : currentSession.createdAt)) {
      right = middle;
    } else {
      left = middle;
    }
  }

  // Возвращаем последнюю сессию если ничего не найдено
  return [(list === null || list === void 0 || (_list$slice = list.slice(-1)) === null || _list$slice === void 0 ? void 0 : _list$slice[0]) || {}, list.length - 1];
};

// Функция для проверки отправки сообщения в разных сессиях
export var checkAndUpdateMessageStatus = function checkAndUpdateMessageStatus(messageId, session) {
  var message = session === null || session === void 0 ? void 0 : session.messages.find(function (item) {
    return item.messageId === messageId;
  });
  if (message) {
    if ((message === null || message === void 0 ? void 0 : message.messageStatus) !== MessageStatus.delivered) {
      message.messageStatus = MessageStatus.failed;
    }
    return true;
  }
  return false;
};